import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const SunCloud = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 224 101">
    <circle cx="65.5" cy="45.5" r="45.5" fill="#FFC14A" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M21 97h188a29.5 29.5 0 0 0-33.5-36.6 46.5 46.5 0 0 0-90.2 9.9 18.5 18.5 0 0 0-23 8.3 18.5 18.5 0 0 0-19.8 7A13.5 13.5 0 0 0 21 97Z"
      clipRule="evenodd"
    />
    <rect width="224" height="4" y="97" fill="#fff" rx="2" />
  </svg>,
);
